import React from "react";
import DataTable from "react-data-table-component";

const customStyles = {
  table: {
    style: {
      borderRadius: "10px",
      overflow: "hidden",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#595A5B1A", 
      fontWeight: 500,
      fontSize: "17px",
      color: "#374151",
      minHeight: "58px",
    },
  },
  rows: {
    style: {
      fontSize: "16px",
      minHeight: "55px",
    },
  },
  headCells: {
    style: {
      color: "#374151", 
    },
  },
};

const CommonDataTable = ({
  columns,
  data,
  title = "",
  pagination = true,
  paginationServer = false,
  paginationTotalRows = 0,
  onChangePage,
    onChangeRowsPerPage,

}) => {
  return (
    <div className="rounded-lg pt-3 pb-5">
      <DataTable
        columns={columns}
        data={data}
        customStyles={customStyles}
        highlightOnHover
        pagination={pagination}
        paginationServer={paginationServer}
        paginationTotalRows={paginationTotalRows}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        persistTableHead
        responsive
      />
    </div>
  );
};

export default CommonDataTable;
